import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';
import LogRocketService from 'services/logRocketService';

export const useLogRocket = () => {
  const { UserStore } = useStore();
  const logRocketService = LogRocketService.getInstance();

  useEffect(() => {
    // Only initialize LogRocket if it's enabled via environment variable
    if (logRocketService.shouldInitialize) {
      logRocketService.initialize();
    } else {
      console.warn('LogRocket is disabled - skipping initialization');
    }
  }, []);

  useEffect(() => {
    // Only identify user if LogRocket is active
    if (logRocketService.isActive && UserStore.isAuthenticated && UserStore.userMetadata) {
      logRocketService.identifyUser(UserStore.userMetadata as any);
    }
  }, [UserStore.isAuthenticated, UserStore.userMetadata]);

  return {
    trackEvent: logRocketService.trackEvent.bind(logRocketService),
    captureError: logRocketService.captureError.bind(logRocketService),
    getSessionURL: logRocketService.getSessionURL.bind(logRocketService),
    isActive: logRocketService.isActive
  };
};
